export default {
  繁體中文: '繁體中文',
  英语: 'English',
  '英语为谷歌翻译，可能存在翻译不准确的情况，如有问题请咨询管理员调整翻译':
    'English is translated by Google, which may have inaccurate translations. If you have any questions, please consult the administrator to adjust the translation',
  歡迎使用: 'Welcome',
  切換淺色: 'Switch to Light',
  切換深色: 'Switch to Dark',
  登出: 'Log out',
  後台入口: 'Backend Portal',
  用戶管理: 'User Management',
  後台管理: 'Backend Management',
  權限管理: 'Permission Management',
  用戶權限: 'User Permissions',
  權限點: 'Permission Points',
  日誌管理: 'Log Management',
  登入日誌: 'Login Logs',
  介面訪問日誌: 'API Access Logs',
  後台訪問日誌: 'Backend Access Logs',
  鑑權日誌: 'Auth Logs',
  操作日誌: 'Operation Logs',
  觸達管理: 'Reach Management',
  系統訊息: 'System Messages',
  個後台: ' backends',
  已篩選: 'Filtered',
  搜尋後台: 'Search backends',
  名稱: 'Name',
  簡介: 'Description',
  操作: 'Actions',
  拖動排序: 'Drag to reorder',
  進入系統: 'Enter',
  暫無後台: 'No backends',
  列表視圖: 'List view',
  卡片視圖: 'Card view',
  視圖切換: 'View mode',
  打開方式: 'Open link in',
  當前標籤頁打開: 'Open in current tab',
  新建標籤頁打開: 'Open in new tab',
  取消: 'Cancel',
  請選擇您的主體: 'Please select your organization',
  '此舉為區分不同主體用戶來源，請選擇您的主體，否則無法正常登錄':
    'Please select your organization to identify your account source, otherwise login will fail',
  廣州弘策網絡科技有限公司: '廣州弘策網絡科技有限公司',
  'HEAVEN POWER INTERNATIONAL LIMITED': 'HEAVEN POWER INTERNATIONAL LIMITED',
  广东很久文化传播有限公司: '广东很久文化传播有限公司',
  確定: 'Confirm',
  提示: 'Tip',
  搜索: 'Search',
  重置: 'Reset',
  查詢: 'Query',
  新增: 'Add',
  編輯: 'Edit',
  刪除: 'Delete',
  保存: 'Save',
  關閉: 'Close',
  暫無數據: 'No data',
  全部: 'All',
  狀態: 'Status',
  創建時間: 'Created at',
  更新時間: 'Updated at',
  正式環境: 'Production',
  測試環境: 'Sandbox',
  本地環境: 'Local',
  其他應用: 'Other Apps',
  開發環境: 'Development',
  未知系統: 'Unknown',
  驗證安全手機: 'Verify secure phone',
  '您的帳號開啟了手機驗證，請在獲取驗證碼之後，輸入您手機上接收到的驗證碼（請查看簡訊驗證碼或釘釘應用的驗證碼資訊）。':
    'Your account has mobile verification enabled. After requesting a code, enter the verification code received on your phone (check SMS or DingTalk).',
  手機號碼: 'Phone number',
  驗證碼: 'Verification code',
  輸入手機收到的驗證碼: 'Enter the code from your phone',
  獲取驗證碼: 'Send code',
  '{n}秒後重試': 'Retry in {n}s',
  記住這台設備7天內無需再次驗證: 'Remember this device (skip verification for 7 days)',
  提交驗證: 'Submit',
  用戶資訊異常請刷新重試: 'User info error. Please refresh and try again.',
  驗證碼已發送: 'Verification code sent',
  驗證失敗請刷新重試: 'Verification failed. Please refresh and try again.',
};
